module.exports = __webpack_public_path__ + "static/media/ss2020_sylas_garen_lux_1920x1080.618b5261.mp4";